import React, { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useUserDataStore } from '../stateStores/User'
import LoadingSpinner from '../components/LoadingSpinner'

function Logout(): React.JSX.Element {
    const { logout } = useAuth0()
    const { clearUserData } = useUserDataStore()

    useEffect(() => {
        clearUserData()
        logout({
            logoutParams: {
                // once logged out head back to the main login page
                returnTo: window.location.origin,
            },
        })
    }, [logout, clearUserData])

    return <LoadingSpinner />
}

export default Logout
